import { combineReducers } from 'redux';
import { authorizationApi } from './services/authorization/api';
import auth from "./services/authorization/slices"
import { graphqlApi } from './services/graphql/api';
import globalAlertsSlice from './services/graphql/slices/global-alerts-slice';
import { adminApi } from './AdminDashboard/services/adminApi';

export default combineReducers({ 
    [authorizationApi.reducerPath]: authorizationApi.reducer,
    authentication: auth,
    [graphqlApi.reducerPath]: graphqlApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
    globalAlertsSlice,
})